import { createAction } from '@reduxjs/toolkit';

import type { Movement, MovementsResponse } from 'api/operations/models';
import type {
  PositionData,
  PositionsResponse,
} from 'commons/modules/service/positions';

import { createReportSlice } from './reportStore';
import type { RootState } from './configureStore';

const initialFilters = {
  account: '',
  advisor: '',
  client: '',
  institute: '',
  instrument: '',
  issuer: '',
  marketType: '',
  operationType: '',
  portfolio: '',
  strategy: '',
  classification: '',
};

// ======================================================
// 🔹 Acciones custom para operation (operationReports)
// ======================================================
export const setReportType = createAction<string>('operation/setReportType');
export const setOperationData = createAction<
  PositionsResponse | MovementsResponse
>('operation/setOperationData');
export const setSelected = createAction<any[]>('operation/setSelected');
export const setCheckedAll = createAction<boolean>('operation/setCheckedAll');
export const setIndeterminateCheck = createAction<boolean>(
  'operation/setIndeterminateCheck',
);

// ======================================================
// 🔹 Slice usando el store genérico
// ======================================================
const slice = createReportSlice<Movement | PositionData>(
  'operation',
  initialFilters,
  (builder) => {
    builder
      .addCase(setReportType, (state, action) => {
        state.reportType = action.payload;
      })
      .addCase(setOperationData, (state, action) => {
        state.data = action.payload.data;
        state.total = action.payload.pagination?.total || 0;
      })
      .addCase(setSelected, (state, action) => {
        state.selected = action.payload;
      })
      .addCase(setCheckedAll, (state, action) => {
        state.checkedAll = action.payload;
      })
      .addCase(setIndeterminateCheck, (state, action) => {
        state.indeterminateCheck = action.payload;
      });
  },
);

// ======================================================
// 🔹 Inicialización de campos custom
// ======================================================
const baseReducer = slice.reducer;
export default (state: any, action: any) => {
  if (state === undefined) {
    return baseReducer(
      {
        ...baseReducer(undefined, { type: '@@INIT' }),
        reportType: 'Posiciones',
        selected: [],
        notSelected: [],
        checkedAll: false,
        indeterminateCheck: false,
      },
      action,
    );
  }
  return baseReducer(state, action);
};

// Selectores específicos de operation
export const getReportType = (state: RootState) =>
  state.entities.operation.reportType || 'Posiciones';
export const getSelected = (state: RootState) =>
  state.entities.operation.selected || [];
export const getNotSelected = (state: RootState) =>
  state.entities.operation.notSelected || [];
export const getCheckedAll = (state: RootState) =>
  state.entities.operation.checkedAll || false;
export const getIndeterminateCheck = (state: RootState) =>
  state.entities.operation.indeterminateCheck || false;
